import React from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { DialogProps } from '../../types/dialog.types'
import Button from '../../buttons/button'

const Dialog: React.FC<DialogProps> = ({
    actions,
    className,
    children,
    open,
    onClose,
    size,
    title
}) => {
    const actionsToRender = typeof actions === 'function' ? actions(onClose) : actions
    return (
        <Modal className={className} isOpen={open} toggle={onClose} size={size}>
            {Boolean(title) && <ModalHeader toggle={onClose}>{title}</ModalHeader>}
            <ModalBody>{children}</ModalBody>
            {actionsToRender && actionsToRender.length > 0 && (
                <ModalFooter>
                    {actionsToRender.map(({ action, disabled, label, variant }, key) => (
                        <Button
                            disabled={disabled}
                            key={`dialog-action-${key}`}
                            color="primary"
                            onClick={action}
                            variant={variant}
                        >
                            {label}
                        </Button>
                    ))}
                </ModalFooter>
            )}
        </Modal>
    )
}

Dialog.defaultProps = {
    size: 'md'
}

export default Dialog
